import React, { useEffect } from "react";
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { Link } from "@StarberryUtils"
import $ from "jquery";
import { navigate } from "@reach/router"
import SearchInputBox from '../predictive-search/search-inputbox';
import "./assets/styles/_index.scss"

const SearchOverlay = (props) => {

    function closeSearchOverlay(e) {
        $("body").removeClass("modal-open").find(".modal-backdrop").remove()
        $(".search-overlay").removeClass("active-search")
    }

    useEffect(() => {
        let url = "/";

        $(".sales_overlay_btn").click(function() {
            var searcValue = $(".property_search_overlay .react-autosuggest__input").val().split(', ').join('-').replace(/ /g,"-").replace(/'/g,"").toLowerCase();
            
            if(searcValue !== "") {
                url = "in-"+searcValue+"/"
            } else {
                url = "in-manchester/"
            }

            // var selectedDropdownSearch = $('#search_dropdown').val();
            // navigate(selectedDropdownSearch+'for-sale/'+url);
            navigate('/property/for-sale/'+url);
            setTimeout(function(){ 
                $("body.modal-open").removeClass("modal-open")
                $(".search-overlay").removeClass("active-search")
                $(".search-modal").remove();    
            }, 1000);
        })

        $(".rent_overlay_btn").click(function() {
            var searcValue = $(".property_search_overlay .react-autosuggest__input").val().split(', ').join('-').replace(/ /g,"-").replace(/'/g,"").toLowerCase();
            
            if(searcValue !== "") {
                url = "in-"+searcValue+"/"
            } else {
                url = "in-manchester/"
            }
            
            // var selectedDropdownSearch = $('#search_dropdown').val();
            // navigate(selectedDropdownSearch+'to-rent/'+url);
            navigate('/property/to-rent/'+url);
            setTimeout(function(){ 
                $("body.modal-open").removeClass("modal-open")
                $(".search-overlay").removeClass("active-search")
                $(".search-modal").remove();
            }, 1000);
        })
    },[]);

    return(
        <>
            <div className="search-overlay">
                <a href="javascript:void(0)" onClick={closeSearchOverlay}><div id="nav-icon-search">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div></a>
                <Container className="property-search-overlay_vertical_align">
                    <Row>
                        <Col lg={10}>
                            <Tabs defaultActiveKey="propertysearch" id="uncontrolled-tab-example" className="search-tab">
                                <Tab eventKey="propertysearch" title="Property Search">
                                    <div className="input-group mb-3 property-search-overlay">
                                        {/* <select className="search-select" id="search_dropdown">
                                            <option value="/property/">Residential</option>
                                        </select> */}
                                        <div className="input-group-prepend property-search-width property-search_overlay property_search_overlay">
                                            <SearchInputBox />
                                            {/* <input type="text" id="searchinput" placeholder="Postcode, Town or City" name="search" class="form-control search-property-input" /> */}
                                        </div>
                                        <div className="property-search-btn_wrapper">
                                            <a href="javascript:void(0)" className="btn sales_overlay_btn">Buy</a>
                                            <a href="javascript:void(0)" className="btn rent_overlay_btn">Rent</a>
                                        </div>
                                    </div>
                                </Tab>
                            </Tabs>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default SearchOverlay